import { defineMessages } from 'react-intl'

const scope =
  'platform.banking.features.createExternalBankAccount.presenters.createExternalBankAccountFormPresenter'

export default defineMessages({
  successToastTitle: {
    id: `${scope}.successToastTitle`,
    defaultMessage: 'Success',
  },
  successToastMessage: {
    id: `${scope}.successToastMessage`,
    defaultMessage: '{name} has been created.',
  },
  errorToastTitle: {
    id: `${scope}.errorToastTitle`,
    defaultMessage: 'Error',
  },
  errorToastMessage: {
    id: `${scope}.errorToastMessage`,
    defaultMessage: 'Unable to create the account.',
  },
})
